import { getQueryStringParamsFromStringUrl, logger } from '$utils'
import { defer } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import useStockStore from '../../../store'
import dayjs from 'dayjs'

export default async function loader({ request }) {
  logger.debug(
    '[loader] About to await AppState being ready in Add Supplier Statement loader'
  )
  await isAppStateReady()
  logger.debug(
    '[loader] AppState should now be ready in Add Supplier Statement loader'
  )

  const { start, end, supplierId } = getQueryStringParamsFromStringUrl(
    request.url
  )

  const getStockReceivedItems = useStockStore
    .getState()
    .getStockReceivedRows(dayjs(start), dayjs(end), supplierId, true)

  return defer({
    data: Promise.all([getStockReceivedItems])
      .then(() => true)
      .catch((error) => {
        logger.error('Add Supplier Statement Promise.all error', error)
        return false
      }),
  })
}
